import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Purpose } from "./components/Purpose";
import { OnlineStore } from "./components/OnlineStore";
import { Contact } from "./components/Contact";
import { Location } from "./components/Location";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { WhatsAppButton } from "./components/WhatsAppButton";
import WarrantyPage from "./pages/WarrantyPage";
import DespoluirArticlePage from "./pages/DespoluirArticlePage";
import { NewsSlider } from "./components/NewsSlider";

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <NewsSlider />
        <About />
        <Purpose />
        <OnlineStore />
        <Contact />
        <Location />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <WhatsAppButton />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/garantia" element={<WarrantyPage />} />
          <Route path="/noticias/rota-eficiencia-sustentavel" element={<DespoluirArticlePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
